import { reactive } from 'vue';

const useFiltersParams = (structure) => reactive(Object.keys(structure).reduce((acc, key) => ({ ...acc, [key]: structure[key].value }), {}));

export {
    useFiltersParams
}
